import Glyph from 'components/Glyph.jsx';
import List from 'components/List.jsx';
import React from 'react';
import TabView from 'components/TabView.jsx';
import Text from 'components/Text.jsx';

import cx from 'classnames';

import styles from './styles/UniversalComposerTabView.css';

export default class UniversalComposerTabView extends React.Component {
  static propTypes = {
    title: React.PropTypes.string,
    subtext: React.PropTypes.string,
    children: React.PropTypes.node.isRequired,
  };

  render() {
    const { title, subtext, children } = this.props;
    return (
      <TabView
        viewRenderer={({ tabList, panel, ...props }) => (
          <div
            {...props}
            className={cx(styles.this, props.className)}>
            <div className={styles.header}>
              {title &&
                <h2 className={styles.title}>
                  <Text color="pitch" size="xxlarge">
                    {title}
                  </Text>
                </h2>
              }
              {subtext &&
                <Text
                  className={styles.subtext}
                  color="koala"
                  size="xsmall">
                  {subtext}
                </Text>
              }
              {tabList}
            </div>
            <div className={styles.content}>
              {panel}
            </div>
          </div>
        )}
        tabListRenderer={({ tabs, ...props }) => (
          <List {...props} className={styles.tabList}>
            {tabs}
          </List>
        )}
        tabRenderer={({ panel, selected, ...props }) => (
          <a
            {...props}
            className={cx(styles.tab, {
              [styles.selectedTab]: selected,
            })}>
            <Text truncate>
              {panel.props.glyphName &&
                <Glyph
                  className={styles.tabGlyph}
                  name={panel.props.glyphName}
                  size={panel.props.glyphSize}
                />
              }
              {panel.props.name}
            </Text>
          </a>
        )}>
        {children}
      </TabView>
    );
  }
}

export const Panel = ({ children, className, ...props }) => (
  <TabView.Panel
    {...props}
    className={cx(styles.panel, className)}>
    {children}
  </TabView.Panel>
);

UniversalComposerTabView.Panel = Panel;



// WEBPACK FOOTER //
// ./src/chat/components/UniversalComposerTabView.jsx